/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Allopportunities2Inputs */

const en_coinvestments_filters_allopportunities2 = /** @type {(inputs: Coinvestments_Filters_Allopportunities2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All deals`)
};

/**
* | output |
* | --- |
* | "All deals" |
*
* @param {Coinvestments_Filters_Allopportunities2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_allopportunities2 = /** @type {((inputs?: Coinvestments_Filters_Allopportunities2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Allopportunities2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_allopportunities2(inputs)
});
export { coinvestments_filters_allopportunities2 as "coInvestments_filters_allOpportunities" }